import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  ContractProductSchema,
  ContractTypeSchema,
  SignableProductSchema,
} from "../models";

const toSignContractSchema = z.object({
  type: ContractTypeSchema,
  product: ContractProductSchema,
  versionKey: z.string(),
  publishAt: z.string().nullable(),
  changelog: z.string().nullable(),
  /** Short-lived signed GCS URL; null when the contract has no PDF. */
  pdfUrl: z.string().nullable(),
});

const api = makeApi([
  {
    alias: "getToSign",
    method: "get",
    path: "/api/v1/contract/to-sign",
    parameters: [
      {
        name: "product",
        type: "Query",
        schema: SignableProductSchema,
      },
    ],
    response: z.object({
      orgTimezone: z.string(),
      contracts: z.array(toSignContractSchema),
    }),
  },
  {
    alias: "getAgreements",
    method: "get",
    path: "/api/v1/contract/agreements",
    response: z.object({
      agreements: z.array(
        z.object({
          contractId: z.number().int(),
          type: ContractTypeSchema,
          product: ContractProductSchema,
          agreedVersionKey: z.string(),
          orgTimezone: z.string(),
          userEmail: z.string(),
          createdAt: z.string(),
          isCurrentVersion: z.boolean(),
          pdfUrl: z.string().nullable().optional(),
        }),
      ),
    }),
  },
  {
    alias: "agree",
    method: "post",
    path: "/api/v1/contract/agree",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: z.object({
          product: SignableProductSchema,
          versionKeys: z.array(z.string()).min(1),
        }),
      },
    ],
    response: z.object({
      agreed: z.array(
        z.object({
          type: ContractTypeSchema,
          product: ContractProductSchema,
          versionKey: z.string(),
        }),
      ),
      createdAt: z.string(),
    }),
  },
]);

export { api };
